module.exports = __webpack_public_path__ + "static/media/question.228da2bd.mp3";